import { StyleSheet } from 'aphrodite/no-important';
import { color, iconUrl } from './vars';

export const playIcon = StyleSheet.create({
	icPlay: generatePlayIconStyleObj(iconUrl.icPlayMed, '45px'),
	icPlayBig: generatePlayIconStyleObj(iconUrl.icPlayMed, '68px'),
	icPlayTiny: generatePlayIconStyleObj(iconUrl.icPlayTiny, '25px'),
	icPlayHover: {
		backgroundColor: color.black,
		transform: 'scale(1.05)'
	}
});

export const icons = StyleSheet.create({

	icCloseIconWhite:{
		background: `url(${iconUrl.closeIconWhite})`,
		display: 'block',
		width: '18px',
		height: '18px',
	},

	icUpNext: {
		background: `url(${iconUrl.upNext})`,
		display: 'block',
		width: '79px',
		height: '13px',
		marginBottom: '5px',
	},

	icFs: {
		background: `url(${iconUrl.fsWhite})`,
		display: 'block',
		backgroundSize: '59px',
		width: '59px',
		height: '35px',
	}
});

export const shareIcons = StyleSheet.create({
	inlineContainer:{
		display: 'inline-flex',
		marginBottom: '20px'
	},

	icFBShare: generateIcShareStyleObj(iconUrl.fbShareRnd),
	icTwitterShare: generateIcShareStyleObj(iconUrl.twitterShareRnd),
	icLinkShare: generateIcShareStyleObj(iconUrl.linkShareRnd, {border: 'none', outline: 'none'}),
	icEmailShare: generateIcShareStyleObj(iconUrl.emailShareRnd),

	icShare: {
		display: 'block',
		width: '38px',
		height: '38px',
		marginRight: '10px'
	},

});

export const liveIcon = StyleSheet.create({
	icLive: {
		width: '29px',
		height: '13px',
		backgroundImage: `url(${iconUrl.icLive})`,
		backgroundSize: '100%'
	}
});

export const fsgoIcon = StyleSheet.create({
	white: generateFsgoIconStyleObj(iconUrl.fsgoWhite),
	black: generateFsgoIconStyleObj(iconUrl.fsgoBlack)
});

export const keyIcon = StyleSheet.create({
	white: {
		width: '24px',
		height: '10px',
		backgroundImage: `url(${iconUrl.icKey})`,
		backgroundSize: '100%',
		display: 'block'
	}
});

/*
	Helpers for styles rendering
 */

const baseIconsStyle = {
	display: 'block',
	backgroundSize: '100%'
};

function generatePlayIconStyleObj(url, size) {
	return Object.assign({}, baseIconsStyle, {
		backgroundImage: `url(${url})`,
		borderRadius: '50%',
		width: size,
		height: size,
	});
}

function generateFsgoIconStyleObj(url) {
	return Object.assign({}, baseIconsStyle, { height: '100%', backgroundImage: `url(${url})` });
}

function generateIcShareStyleObj(url, custom) {
	let base = {
		background: `url(${url})`,

		':hover':{
			transform: 'scale(1.05)'
		}
	};

	return Object.assign({}, base, custom);
}



// WEBPACK FOOTER //
// ./react-app-src/shared/styles/icons.js